import { useContext } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Underground } from '../../components/Building/parts/Underground';
import { UIText2 } from '@cian/ui-kit';

export const Address = (): React.JSX.Element => {
  const { undergroundInfo, fullAddress } = useContext(CardContext);

  return (
    <div>
      {undergroundInfo && <Underground {...undergroundInfo} />}
      <UIText2 color="gray60_100">{fullAddress}</UIText2>
    </div>
  );
};
